import { render } from "./JustRoll.vue?vue&type=template&id=45728532"
import script from "./JustRoll.vue?vue&type=script&lang=js"
export * from "./JustRoll.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__